// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"393":"aae7af36062398cdd0aa","610":"d49bdece1e2623db4be3"}[chunkId] + ".bundle.js";
};